import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { UserService } from '../../shared/user.service';
import { DatePipe } from '@angular/common';
import swal from 'sweetalert2';

@Component({
  selector: 'app-chit-receipt',
  templateUrl: './chit-receipt.component.html',
  styleUrls: ['./chit-receipt.component.css']
})
export class ChitReceiptComponent implements OnInit {
  display='none';
  disaccdata:any;
  disacopt:any={};
  da:any=[];
  title:string;
  calculated:number;
  disptrans:boolean;
  dispmisc:boolean;
  formrecipt:any={};
  actydata: any;
  actopt: any;
  ac:any={};
  sc:any=[];
  acschdata: any;
  schopt: any;
  branchdt:any;
  brnchopt:any;
  b:any={};
  accno: any;
  pigmydata: any;
  pigopt: any;
  pg:any={};
  custdata: any;
  custopt: any;
  DateValues:string;
  today = new Date(); 
  notaccno: any;
  constructor(private service:UserService,private datePipe:DatePipe)
   { }

   ngOnInit() 
   {

     this.disptrans=true;
     this.actype();
     this.getbranchd();
     this.formrecipt.decide="Recipt";
     this.title="Credit / Recipt";
   
  
   }

   transradio()
   {
   
     this.disptrans=true;
     this.dispmisc=false;
     this.formrecipt.miscrad=false;
 
   }
   miscradio()
   {  
     this.formrecipt.tranrad=false;
     this.disptrans=false;
     this.dispmisc=true;
   }
 
   actype()
   {
     debugger;
     this.actydata=this.service.gettrans();
     this.actydata.subscribe(
       (actyres:any)=>{
         this.actopt=actyres;
        
        }
     )
   }
 
   acscheme(module:number)
   {
     debugger;
     this.acschdata=this.service.getschemechit(module);
     this.acschdata.subscribe(
       (schres:any)=>
       {debugger;
         this.schopt=schres;
         console.log(this.schopt);
       }
     )
   }
 
   acgetsub(schnum: any)
   {
     if(schnum.length==1)
     {
       this.formrecipt.acglsubid='00'+schnum;
     }
     else if(schnum.length==2)
     {
       this.formrecipt.acglsubid='0'+schnum;
     }
     else if(schnum.length==3)
     {
       this.formrecipt.acglsubid=schnum;
     } //this.acglsubid= new string.concat(0,this.schnum); 
   }
 
   getbranchd()
   {
     debugger;
    this.branchdt=this.service.getbranch();
    this.branchdt.subscribe(
     (bresponse:any)=>{
       this.brnchopt=bresponse.BranchModels;
       console.log(bresponse.BranchModels);
     })
   }
   acsetbranch(bid:any)
   {
     debugger;
     this.formrecipt.tbranchsel=bid;
     if(bid.length==1)
     {
       this.formrecipt.branch='00'+bid;
       this.formrecipt.tacbranch='00'+bid;
     }
     else if(bid.length==2)
     {
       this.formrecipt.branch='0'+bid;
       this.formrecipt.tacbranch='0'+bid;
     }
     else if(bid.length==3)
     {
       this.formrecipt.branch=bid;
       this.formrecipt.tacbranch=bid;
     }
   }
   onKey(branch:any,yrnd:any,acn:any,subid:any)
    { // without type info
     this.accno = branch+yrnd+acn+subid;    //event.target.value + ' | ';
     console.log(this.accno);
    // this.pigmyaccountfetch(this.accno,subid,branch);
   }
 
   agetname(BRANCH_ID:number,actype:number,GLSUB_ID:number,acbranch:number,yrnd:string,ac_no:string,glsub:number) { // without type info
     debugger;
          var accno = acbranch+yrnd+ac_no+glsub;    //event.target.value + ' | ';
         this.customeracc(BRANCH_ID,actype,GLSUB_ID,accno);
     
       }
  customeracc(BRANCH_ID:number,actype:number,acscheme:number,acc_no:string)
       {
       debugger;
        this.custdata=this.service.chitcustlist(this.chckbint(BRANCH_ID),this.chckbint(actype),this.chckbint(acscheme),this.chckbstr(acc_no));
        this.custdata.subscribe(
          (cusres:any)=>{
          this.custopt=cusres;
          console.log(this.custopt);
          debugger;
          this.formrecipt.Name=this.chckbstr(cusres.NAME);// this.custopt.NAME;
         this.formrecipt.opendate=this.getdatefun(this.custopt.OPEN_DT);
          this.formrecipt.transdate= this.getdatefun(this.today);
          this.formrecipt.LF=this.custopt.LF;
          this.formrecipt.membno=this.custopt.REF_NO;
          this.formrecipt.currbal=this.custopt.CURR_BAL;
          this.formrecipt.balcf=this.custopt.CURR_BAL;
          this.formrecipt.Custid=this.custopt.FCODE;
          this.formrecipt.minbal=this.custopt.MIN_BAL;
          this.formrecipt.custadd =this.custopt.DIS_ADD;
 
          
        }
        )
       }
       getdatefun(indt:any)
       {
         this.DateValues=this.datePipe.transform(indt,'yyyy-MM-dd');
         return this.DateValues;
      }
  
 
  chckbbol(arg:boolean)
  {
    if (arg!=null)
    {
      return true;
    }
    else
      return false;
  }
  
  chckbint(arg:number)
  {
    if (arg!=null)
    {
      return arg;
    }
    else
      return 0;
  }
   
  chckbstr(arg:string)
  {
    if (arg!=null)
    {
      return arg;
    }
    else
      return "0";
  }
 
  chckdt(arg:Date)
  {
    if (arg!=null)
    {
      return arg;
    }
  }
   getnar(acno:string,glsubid:any,name:string)
   {
     debugger;
     var nar="By "+glsubid.substring(1,2)+acno.substring(8,6)+" / "+name;
      return nar;
   }

   addamt(amt:number,bfbal:number)
   {
    this.calculated=(+this.checknull(amt))+(+this.checknull(bfbal));
    this.formrecipt.balcf=this.calculated;
    this.formrecipt.net=amt;
   }

   subamt(amt:number,bfbal:number)
   {
    this.calculated=(+this.checknull(bfbal))-(+this.checknull(amt));
    this.formrecipt.balcf=this.calculated;
    this.formrecipt.net=amt;
   }
   checknull(chknum:number)
   {
     debugger;
     if(chknum==null)
        return 0;
      else
        return chknum;
   }

   dorecipttrans(formrecipt:NgForm)
   {
     debugger;
    document.getElementById('loader-spinner').style.display = "block";
    this.service.Reciptcredit(formrecipt).subscribe(res=>{
      this.resetForm(formrecipt)
      document.getElementById('loader-spinner').style.display = "none";  
      swal('Done!', 'Credited', 'success');
     },
    (error) => {
      document.getElementById('loader-spinner').style.display = "none";
      swal('Warning!', 'Something went wrong', 'warning');
    });
   }

   accountnumber(bran:string,yrnd:string,acno:string,gsub:string)
   {
      return bran.trim()+yrnd.trim()+acno.trim()+gsub.trim();
   }
   resetForm(form?: NgForm)
  {
    if(form!=null)
    {
      this.formrecipt.actype="";
      this.formrecipt.acscheme="";
      this.formrecipt.Transmode="";
      this.formrecipt.transdate="";
      this.formrecipt.opendate="";
      this.formrecipt.Transtype="";
      this.formrecipt.LF="";
      this.formrecipt.branchsel="";
      this.formrecipt.membno="";
      this.formrecipt.branch="";
      this.formrecipt.yrnd="";
      this.formrecipt.ac_no="";
      this.formrecipt.acglsubid="";
      this.formrecipt.Custid="";
      this.formrecipt.Name="";
      this.formrecipt.custadd="";

      this.formrecipt.tranrad="";
      this.formrecipt.miscrad="";
      this.formrecipt.currbal="";
      this.formrecipt.minbal="";
      this.formrecipt.crdt="";
      this.formrecipt.balcf="";
      this.formrecipt.net="";
      this.formrecipt.remrks="";

    }
  }
 
  // aonKey(branch:any,yrnd:any,acn:any,subid:any)
  // {
  //   debugger;
  // this.accno = this.checkstringnul(branch)+this.checkstringnul(yrnd)+this.checkstringnul(acn)+this.checkstringnul(subid);
  // this.notaccno=this.checkstringnul(acn)+this.checkstringnul(subid);
  //   if(this.accno.length<16)
  //   {
  //     this.disaccdata=this.service.getallaccountunivers(this.notaccno,subid);
  //     this.disaccdata.subscribe(
  //       (accres:any)=>{
  //         this.disacopt=accres;
  //         console.log(this.disacopt);
  //         this.openModalDialog();
  //       })
     
  //   }
  //   else
  //   {
      
  //    // this.pigmyaccountfetch(this.accno,subid,branch);
  //   }
  // }
  openModalDialog(){
    this.display='block'; //Set block css
  }
  
  closeModalDialog(){
  this.display='none'; //set none css after close dialog
  }
  checkstringnul(str:any)
  {
    if(str!=null)
    {
      return str;
    }
    else
     return "";
  }

  getname(BRANCH_ID:number,actype:number,GLSUB_ID:any,acbranch:number,yrnd:string,ac_no:string,glsub:number) { // without type info
    debugger;
         var accno = acbranch+yrnd+ac_no+glsub;    //event.target.value + ' | ';

         debugger;
         this.accno = this.checkstringnul(acbranch)+this.checkstringnul(yrnd)+this.checkstringnul(ac_no)+this.checkstringnul(glsub);
         this.notaccno=this.checkstringnul(ac_no)+this.checkstringnul(glsub);
           if(this.accno.length<16)
           {
             this.disaccdata=this.service.getallaccountunivers(this.notaccno,GLSUB_ID,BRANCH_ID);
             this.disaccdata.subscribe(
               (accres:any)=>{
                 this.disacopt=accres;
                 console.log(this.disacopt);
                 this.openModalDialog();
               })
            
           }
           else
           {
            this.customeracc(BRANCH_ID,actype,GLSUB_ID,accno);
            // this.pigmyaccountfetch(this.accno,subid,branch);
           }
       
    
      }

      Getbynumber(accn:string,subid:number,branch:number,actype:number,BRANCH_ID:number)
      {
        debugger;
        for(let i=0;i< this.disacopt.length;i++)
        {
          if(this.disacopt[i].ACC_NO==accn)
          { debugger;
            let accnum=this.disacopt[i].ACC_NO;
            let acnaqm=this.disacopt[i].NAME;
            this.formrecipt.branch=accnum.substring(0,3);
            this.formrecipt.yrnd=accnum.substring(7,3);
            this.formrecipt.ac_no=accnum.substring(13,7);
            console.log(accnum.substring(13,7));
           // this.formpigmypart.glsubid=accnum.substring(16,13);
           debugger;
            this.customeracc(BRANCH_ID,actype,subid,accnum);
            this.closeModalDialog();
          }
        }
      }
      Getbyname(name:string,subid:number,branch:number,actype:number,accno:string,BRANCH_ID:number)
      {debugger;
        for(let i=0;i< this.disacopt.length;i++)
        {
          if(this.disacopt[i].NAME==name)
          {
            debugger;
            let accnum=this.disacopt[i].ACC_NO;
            let acnaqm=this.disacopt[i].NAME;
            this.formrecipt.branch=accnum.substring(0,3);
            this.formrecipt.yrnd=accnum.substring(7,3);
            this.formrecipt.accno=accnum.substring(13,7);
           // this.formpigmypart.glsubid=accnum.substring(16,13);
            //this.pigmyaccountfetch(accnum,subid,branch);
           this.customeracc(BRANCH_ID,actype,subid,accno);
            this.closeModalDialog();
          } 
        }
    
      }

 }

 


// WEBPACK FOOTER //
// ./src/app/chitfund/chit-receipt/chit-receipt.component.ts